export function mapTimeZone(
  timezone: string,
  config: { [key: string]: string } | undefined
): string {
  if (!config) {
    return timezone;
  }

  const entries = Object.entries(config);

  let returnValue = "";

  for (const [shortId, zoneId] of entries) {
    if (shortId === timezone) {
      returnValue = zoneId;
      break;
    }
    if (zoneId === timezone) {
      returnValue = shortId;
      break;
    }
  }

  return returnValue;
}
